import React from 'react';
import './Purchase.css';

const Purchase = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/213XXXXXXXXX', '_blank');
  };

  return (
    <section className="purchase-section">
      <div className="container">
        <div className="purchase-card">
          <div className="purchase-icon">💼</div>
          <h2 className="purchase-title">
            Wholesale & Partnership
            <span className="title-kanji">卸売り</span>
          </h2>
          <p className="purchase-text">
            Interested in bulk orders or retail partnership? Contact us directly
            via WhatsApp for exclusive wholesale pricing and collaboration opportunities.
          </p>
          <button className="purchase-whatsapp-btn" onClick={handleWhatsApp}>
            <span>Contact via WhatsApp</span>
            <span className="button-kanji">お問い合わせ</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Purchase;
